/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  TextField, Typography, Grid,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import ToolTip from './ToolTip';
import { resourceFormStyle } from '../../css/style';
import {
  validationErrorMessages,
  LONG_TEXT_FIELD_HEIGHT,
  MAX_CHAR_DESCRIBE_TEXTFIELD,
} from '../../data/Constants';

const styles = resourceFormStyle();
class FormTextField extends Component {
  validateInput = ({ newValue }) => {
    const { field, customValidator } = this.props;
    const { isRequired } = field;
    const { isRequiredError } = validationErrorMessages.field;
    let errorMsg = '';
    if (isRequired && !newValue) {
      errorMsg = isRequiredError;
    }
    if (customValidator) {
      errorMsg = customValidator({ newValue });
    }
    return errorMsg;
  }

  onChangeInput = (event) => {
    const { handleValueChange, field } = this.props;
    const { key } = field;
    const newValue = event.target.value;
    const errorMsg = this.validateInput({ newValue });
    handleValueChange({ key, newValue, errorMsg });
  }

  render() {
    const { field, isMultipleRow } = this.props;
    const {
      key,
      title,
      width,
      errorMessage,
      isValid,
      value,
    } = field;
    const { descriptionInputPropStyle, normalInputPropStyle } = styles;
    const inputPropStyle = isMultipleRow ? descriptionInputPropStyle : normalInputPropStyle;
    return (
      <Grid
        item
        key={field.key}
        xs={field.gridWidth ? parseInt(field.gridWidth, 10) : 'auto'}
        style={styles.gridItem}
      >
        <div>
          <div style={styles.itemTitleContainer}>
            <Typography style={styles.itemTitle}>{`${title}:`}</Typography>
            <ToolTip field={field} width={width} />
          </div>
          <React.Fragment>
            <TextField
              key={key}
              id={key}
              value={value}
              onChange={this.onChangeInput}
              margin="normal"
              multiline={isMultipleRow}
              rows={isMultipleRow ? LONG_TEXT_FIELD_HEIGHT : '0'}
              style={isValid ? styles.textFieldStyle : styles.errorTextFieldStyle }
              inputProps={{ 
                ...inputPropStyle,
                maxLength: MAX_CHAR_DESCRIBE_TEXTFIELD 
              }}
              InputProps={{ disableUnderline: true }}
            />
            <Typography style={styles.errorMessageStyle}>
              {errorMessage}
            </Typography>
          </React.Fragment>
        </div>
      </Grid>
    );
  }
}

FormTextField.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  customValidator: PropTypes.func,
  isMultipleRow: PropTypes.bool,
};

FormTextField.defaultProps = {
  customValidator: null,
  isMultipleRow: false,
};

export default FormTextField;
